const stringToId = require('../../../../utils/string-to-id')

const isBlank = value => value === undefined || value === null || value === ''

const codeToProductId = code => `product:${stringToId(code)}`

module.exports = { isBlank, codeToProductId }
